import {
  PiChat,
  PiLightning,
  PiPaperPlaneTilt,
  PiTrendUp,
} from 'react-icons/pi'
import { MetricCard } from 'components/FbUI/MetricCard'
import type { CampaignStats as CampaignStatsResponse } from 'services/campaigns'

export function CampaignsStatsBar({
  stats,
}: {
  stats?: CampaignStatsResponse
}) {
  const avgRate =
    stats?.avg_interested_rate != null ? `${stats.avg_interested_rate}%` : '—'

  // Borderless MetricCards (icon square + label-over-value), matching the
  // Targets header stats — `border-0` drops the stroke, padding/bg stay.
  // 4-up grid so they fill the page width with even breathing room.
  return (
    <div className="grid grid-cols-4 gap-3">
      <MetricCard
        className="border-0 px-0"
        icon={<PiPaperPlaneTilt size={18} />}
        label="Emails Sent"
        value={String(stats?.sent ?? '—')}
      />
      <MetricCard
        className="border-0 px-0"
        icon={<PiLightning size={18} />}
        label="Active Campaigns"
        value={String(stats?.active_campaigns ?? '—')}
      />
      <MetricCard
        className="border-0 px-0"
        icon={<PiChat size={18} />}
        label="Replies"
        value={String(stats?.replies ?? '—')}
      />
      <MetricCard
        className="border-0 px-0"
        icon={<PiTrendUp size={18} />}
        label="Avg. Interested Rate"
        value={avgRate}
      />
    </div>
  )
}
